import { EPdfFitMode, EPdfOrientation, TPdfAlign, TPdfFitButton, TPdfSize } from './pdf-preview.model';

export const PDF_PAGE_PT: TPdfSize = { width: 595.28, height: 841.89 };
export const PDF_MARGIN_PT = 40;
export const PDF_FONT_NAME = 'helvetica';
export const PDF_FONT_SIZE_PT = 10;
export const PDF_CELL_PADDING_PT = 5;
export const PDF_ROW_PT = 21.5;
export const PDF_LINE_PT = 0.5;
export const PDF_MIN_COLUMN_PT = 24;
export const PDF_RIGHT_EDGE_GAP_PT = 0.001;
export const PDF_SHARE_EPSILON = 1e-9;
export const PDF_SHOWN_COLUMNS_MAX_SHARE = 0.9;

export const PDF_STYLE = {
  text: '#000000',
  headerText: '#979797',
  rule: '#979797',
} as const;

export const PDF_FONT_FAMILY = "Arial, Helvetica, 'Liberation Sans', sans-serif";

export const PDF_REAL_SIZE_K = 4 / 3;
export const PDF_MIN_K = 0.75;
export const PDF_PAGE_FIT_MIN_K = 0.75;
export const PDF_MIN_LINE_PX = 0.5;

export const PDF_CONTENT_FIT_SAMPLE_ROWS = 300;
export const PDF_CONTENT_FIT_PERCENTILE = 0.9;
export const PDF_CONTENT_FIT_MAX_SHARE = 0.4;

export const PDF_KEYBOARD_STEP_PT = 2.835;
export const PDF_KEYBOARD_LARGE_STEP_PT = 14.175;

export const PDF_VIEWPORT_PADDING_X_PX = 48;
export const PDF_VIEWPORT_PADDING_Y_PX = 32;

export const PDF_PROVIDER_DEBOUNCE_MS = 150;
export const PDF_PROVIDER_SLOW_MS = 300;
export const PDF_PROVIDER_RETRY_MS = 150;
export const PDF_PROVIDER_MAX_ATTEMPTS = 5;
export const PDF_PULSE_DELAY_MS = 400;
export const PDF_PULSE_DURATION_MS = 4000;

export const PDF_GRIP_MAX_PX = 12;
export const PDF_GRIP_ACTIVE_PX = 16;
export const PDF_GRIP_INSET_PX = 6;

export const PDF_THUMBNAIL_LONG_PX = 102;
export const PDF_THUMBNAIL_SHORT_PX = 72;
export const PDF_THUMBNAIL_KEY_STEP = 0.1;

export const PDF_SKELETON_GAP_PX = 6;
export const PDF_COLUMN_SKELETON_COUNT = 8;

export const PDF_WIN_ANSI_EXTRA_CODE_POINTS: ReadonlySet<number> = new Set([
  0x20ac, 0x201a, 0x0192, 0x201e, 0x2026, 0x2020, 0x2021, 0x02c6, 0x2030, 0x0160, 0x2039, 0x0152, 0x017d,
  0x2018, 0x2019, 0x201c, 0x201d, 0x2022, 0x2013, 0x2014, 0x02dc, 0x2122, 0x0161, 0x203a, 0x0153, 0x017e,
  0x0178,
]);
export const PDF_WIN_ANSI_CONTROL_CODE_POINTS: ReadonlySet<number> = new Set([0x0a]);
export const PDF_UNSUPPORTED_CHARACTER = '?';
export const PDF_CARRIAGE_RETURN_PATTERN = /\r\n?/g;
export const PDF_TAB_PATTERN = /\t/g;
export const PDF_SOFT_HYPHEN_PATTERN = /\u00ad/g;

export const PDF_CELL_JUSTIFY: Readonly<Record<TPdfAlign, string>> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

export const PDF_PAGE_KEY_DIRECTION: Readonly<Record<string, number>> = {
  PageDown: 1,
  PageUp: -1,
};

export const PDF_RESIZE_KEY_DIRECTION: Readonly<Record<string, number>> = {
  ArrowLeft: -1,
  ArrowRight: 1,
};

export const PDF_THUMBNAIL_KEY_DIRECTION: Readonly<Record<string, number>> = {
  ArrowUp: -1,
  ArrowDown: 1,
  PageUp: -3,
  PageDown: 3,
  Home: -100,
  End: 100,
};

export const PDF_FIT_BUTTONS: Readonly<Record<EPdfFitMode, TPdfFitButton>> = {
  [EPdfFitMode.Auto]: { icon: 'zoom-out', label: 'COMPONENTS.DX.PDF_PREVIEW.SHOW_WHOLE_PAGE' },
  [EPdfFitMode.Width]: { icon: 'zoom-out', label: 'COMPONENTS.DX.PDF_PREVIEW.SHOW_WHOLE_PAGE' },
  [EPdfFitMode.Page]: { icon: 'zoom-in', label: 'COMPONENTS.DX.PDF_PREVIEW.ENLARGE_PAGE' },
};

export const PDF_SHEET_FORMAT_LABELS: Readonly<Record<EPdfOrientation, string>> = {
  [EPdfOrientation.Portrait]: 'COMPONENTS.DX.PDF_PREVIEW.A4_PORTRAIT',
  [EPdfOrientation.Landscape]: 'COMPONENTS.DX.PDF_PREVIEW.A4_LANDSCAPE',
};

export const PDF_TOO_MANY_COLUMNS_LABELS: Readonly<Record<EPdfOrientation, string>> = {
  [EPdfOrientation.Portrait]: 'COMPONENTS.DX.PDF_PREVIEW.TOO_MANY_COLUMNS',
  [EPdfOrientation.Landscape]: 'COMPONENTS.DX.PDF_PREVIEW.TOO_MANY_COLUMNS_LANDSCAPE',
};

export const PDF_ENGINE_STRIPPED_COLUMN_OPTIONS = [
  'cellTemplate',
  'editCellTemplate',
  'groupCellTemplate',
  'headerCellTemplate',
  'sortOrder',
  'sortIndex',
  'width',
  'minWidth',
] as const;
